export const transparentize = (hex: string, alpha: any) => {
  let c;
  if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
    c = hex.substring(1).split("");
    if (c.length === 3) c = [c[0], c[0], c[1], c[1], c[2], c[2]];
    c = parseInt(c.join(""), 16);
    return `rgba(${[(c >> 16) & 255, (c >> 8) & 255, c & 255, alpha].join(
      ","
    )})`;
  }
  throw new Error("Bad Hex");
};
